import React from "react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
import "./index.css";
import { IdentityContextProvider } from "./context/IdentityContext";
import { loadConfig } from './config';

loadConfig().then(() => {
   
  const root = createRoot(document.getElementById("root")!); // notice the '!'
      root.render(
      <React.StrictMode>
      <IdentityContextProvider>
      <BrowserRouter>
         <Provider store={store}>
            {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
            <App />
            {/* </LocalizationProvider> */}
         </Provider>
      </BrowserRouter> 
      </IdentityContextProvider>
      </React.StrictMode>
   );

   // If you want to start measuring performance in your app, pass a function
   // to log results (for example: reportWebVitals(console.log))
   // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
   reportWebVitals();

});

